export default __webpack_public_path__ + "static/media/0_YUAN300.29c85e35.jpg";